import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React, { ReactNode } from 'react';

type Props = { isEnable: boolean; children: ReactNode };

const Loading = ({ isEnable, children }: Props) => {
	return (
		<Spin
			indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
			tip="Загрузка..."
			spinning={isEnable}
		>
			{children}
		</Spin>
	);
};

export default Loading;
